import { apiCallCenter } from '@/plugins/axios'

export default {
  getOperadores() {
    return apiCallCenter().get('/agent/login/status')
  },

  logoutForcadoOperador(data) {
    return apiCallCenter().post('/agent/logout', data)
  },
}
